import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { AuthProvider } from "@/context/AuthContext";

createRoot(document.getElementById("root")!).render(
  <BrowserRouter basename="/">
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
